import type { LocationState } from './locationState';
import { locationState } from './locationState';

export function getLocation(): LocationState {
  return locationState.value;
}
